export const type = 'setShippingPriceType';

export const setShippingPrice = (shippingPrice) => ({
    type,
    payload: shippingPrice,
});

